export default __webpack_public_path__ + "locales/sl/Settings.json?hash=6c08f94f4aad04d50814c92f37c6dd4b";